<template>
  <transition-group :name="noTransition ? 'none' : 'list'">
    <slot />
  </transition-group>
</template>

<script setup lang="ts">
import { usePreferredReducedMotion } from '@vueuse/core'
import { computed } from 'vue'
const preferredMotion = usePreferredReducedMotion()
// No transition if user prefers reduced motion
// currently it's very harsh
// we should reduce it to a minimum but not remove it entirely
// TODO
const noTransition = computed(() => {
  return preferredMotion.value === 'reduce'
})
</script>

<style lang="scss">
.list-enter-from {
  opacity: 0;

}

.list-enter-active {
  opacity: 0;
  transform-origin: top left;
  transition: transform 0.25s, opacity 0.25s ease-in-out 0.25s;


  &.sender_bot {
    transform-origin: top right;
  }
}

.list-enter-to {
  opacity: 1;

  // transform: translateX(0) scaleY(1) scaleX(1);
}

.list-move {
  /*  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);  */
  transition: 0.5s all;
}

.list-leave-active {
  transition: 0.5s all;
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scale(0);
  transform-origin: center top;
}
</style>
